import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import UserAchievementsDashboard from '../components/user/UserAchievementsDashboard';

const UserAchievementsPage = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleBack = () => {
    navigate('/dashboard');
  };

  return <UserAchievementsDashboard user={user} onBack={handleBack} />;
};

export default UserAchievementsPage;
